export type Message = {
  id: string;
  from: string;
  date: Date;
  text: string;
  textRating: string;
  subtitle: string;
  subtitleRating: string;
  edited: boolean;
  source: string;
  meta: MessageMeta;
};

export type MessageMeta = {
  currVideoResolution: VideoResolution;
  // Keyed by frame number. A plain object, not a Map — it arrives as JSON over
  // the socket, so a Map here would typecheck against something that cannot
  // exist at runtime.
  segmentResolutions: Record<number, VideoResolution>;
};

export type VideoResolution = {
  width: number;
  height: number;
};

export type SignLanguageRecognitionMessage = {
  source: string;
  translation: string;
  gloss: string;
  userId: string;
  conversationId: string;
  startFrame: number;
  endFrame: number;
  signingInProgress: boolean;
  signerGuide: string;
  videoFPS: number;
  currVideoResolution?: VideoResolution;
};

export type SpeechRecognitionMessage = {
  source: string;
  text: string;
  details: {
    source: string;
    offset: number;
    duration: number;
  };
};

export type SpeechRecognizingMessage = SpeechRecognitionMessage & { userId?: string };

export type TypedMessage = {
  id?: string;
  source: string;
  text: string;
};

export type SystemMessage = {
  text: string;
};

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  userMode: string;
  paused: boolean;
  isAcknowledged: boolean | null;
  isAuthorized: boolean;
  token: string;
  email?: string;
  isWhitelistAdmin?: boolean;
  videoDeviceStatus: DeviceStatusEnum;
  audioDeviceStatus: DeviceStatusEnum;
};

export type RoomUser = {
  id: string;
  firstName: string;
  lastName: string;
  userMode: string;
  paused: boolean;
  videoDeviceStatus: DeviceStatusEnum;
  audioDeviceStatus: DeviceStatusEnum;
};

export type MessagesData = {
  allMessagesCount: number;
  messages: Message[];
};

export type Links = {
  feedback: string;
  learnMore: string;
};

export type RecognitionModelInfo = {
  id: string;
  name: string;
  healthy: boolean;
};

export type ServerAppSettings = {
  links: {
    feedback: string;
    learnMore: string;
  };
  isWriteBacklogVideo: boolean;
  isWriteBacklogAudio: boolean;
  turnServer?: string;
  turnUser?: string;
  turnCredential?: string;
  useTurnServer?: boolean;
  testMode?: boolean;
  showSignerPrompt?: boolean;
  showGloss?: boolean;
  allowMessageEditing?: boolean;
  isModelPickerEnabled?: boolean;
  showInstanceId?: boolean;
  instanceId?: string;
};

export enum DeviceStatusEnum {
  sharingDisabled = 'sharingDisabled',
  disabled = 'disabled',
  active = 'active',
  unknown = 'unknown',
}
